<template>
  <SettingsPageLayout>
    <DetailForm
      v-if="loaded"
      title="Recruiting Landing Page"
      description="Manage the content for your recruiting-focused landing page. Keep in mind, Humaniz will provide you with a custom domain as well (e.g. www.joinhumaniz.io) free of charge as part of your Humaniz subscription. Reach out to support@humaniz.io or your account manager if you need help."
      action="Save"
      cancel="View landing page"
      @handle-action="updateSitePage"
      @handle-cancel="openPage"
    >
      <h3 class="font-bold">General</h3>
      <TextInput
        label="Button Text"
        placeholder="ex. Let's Chat"
        :model-value="landing_page_settings.button_text"
        @update:model-value="value => (landing_page_settings.button_text = value)"
      />

      <h3 class="font-bold">Hero Section</h3>
      <TextInput
        label="Headline"
        placeholder="Some awe-inspiring headline"
        :model-value="landing_page_settings.hero_headline"
        @update:model-value="landing_page_settings.hero_headline = $event"
      />
      <TextAreaInput
        class="mt-2"
        label="Lead Text"
        placeholder="Some interesting lead text"
        :model-value="landing_page_settings.hero_lead"
        @update:model-value="landing_page_settings.hero_lead = $event"
      />

      <h3 class="font-bold mt-12">Team Testimonial Section</h3>
      <TextAreaInput
        class="mt-2"
        label="Testimonial 1 Content"
        placeholder="Some interesting lead text"
        :model-value="landing_page_settings.testimonial_1_content"
        @update:model-value="landing_page_settings.testimonial_1_content = $event"
      />
      <TextInput
        label="Testimonial 1 Name"
        placeholder="Some awe-inspiring headline"
        :model-value="landing_page_settings.testimonial_1_name"
        @update:model-value="landing_page_settings.testimonial_1_name = $event"
      />

      <TextAreaInput
        class="mt-2"
        label="Testimonial 2 Content"
        placeholder="Some interesting lead text"
        :model-value="landing_page_settings.testimonial_2_content"
        @update:model-value="landing_page_settings.testimonial_2_content = $event"
      />
      <TextInput
        label="Testimonial 2 Name"
        placeholder="Some awe-inspiring headline"
        :model-value="landing_page_settings.testimonial_2_name"
        @update:model-value="landing_page_settings.testimonial_2_name = $event"
      />

      <TextAreaInput
        class="mt-2"
        label="Testimonial 3 Content"
        placeholder="Some interesting lead text"
        :model-value="landing_page_settings.testimonial_3_content"
        @update:model-value="landing_page_settings.testimonial_3_content = $event"
      />
      <TextInput
        label="Testimonial 3 Name"
        placeholder="Some awe-inspiring headline"
        :model-value="landing_page_settings.testimonial_3_name"
        @update:model-value="landing_page_settings.testimonial_3_name = $event"
      />

      <h3 class="font-bold">Spotlight Section</h3>
      <TextInput
        label="Headline"
        placeholder="Some awe-inspiring headline"
        :model-value="landing_page_settings.spotlight_headline"
        @update:model-value="landing_page_settings.spotlight_headline = $event"
      />
      <TextAreaInput
        class="mt-2"
        label="Lead Text"
        placeholder="Some interesting lead text"
        :model-value="landing_page_settings.spotlight_lead"
        @update:model-value="landing_page_settings.spotlight_lead = $event"
      />
      <TextAreaInput
        class="mt-2"
        label="Right Column Content"
        placeholder="Some interesting lead text"
        :model-value="landing_page_settings.spotlight_right_column_content"
        @update:model-value="landing_page_settings.spotlight_right_column_content = $event"
      />

      <h3 class="font-bold">Form Section</h3>
      <TextInput
        label="Headline"
        placeholder="Some awe-inspiring headline"
        :model-value="landing_page_settings.form_section_headline"
        @update:model-value="landing_page_settings.form_section_headline = $event"
      />
      <TextAreaInput
        class="mt-2"
        label="Lead Text"
        placeholder="Some interesting lead text"
        :model-value="landing_page_settings.form_section_lead"
        @update:model-value="landing_page_settings.form_section_lead = $event"
      />

      <h3 class="font-bold">Tracking</h3>
      <TextAreaInput
        label="Google Tracking Script"
        placeholder="Google Tracking Script"
        :model-value="landing_page_settings.gtag"
        @update:model-value="landing_page_settings.gtag = $event"
      />
    </DetailForm>
  </SettingsPageLayout>
</template>

<script>
import SettingsPageLayout from '../../SettingsPageLayout/index.vue';
import DetailForm from '../../shared/DetailForm.vue';

export default {
  components: {
    SettingsPageLayout,
    DetailForm,
  },
  data() {
    return {
      loaded: false,
      site_domain: {
        domain: '',
      },
      site_page_id: '',
      site_page_path: '',
      landing_page_settings: {
        hero_lead: '',
        button_text: '',
        hero_headline: '',
        spotlight_lead: '',
        form_section_lead: '',
        spotlight_headline: '',
        testimonial_1_name: '',
        testimonial_2_name: '',
        testimonial_3_name: '',
        form_section_headline: '',
        testimonial_1_content: '',
        testimonial_2_content: '',
        testimonial_3_content: '',
        testimonial_1_image_url: '',
        testimonial_2_image_url: '',
        testimonial_3_image_url: '',
        spotlight_right_column_type: '',
        spotlight_right_column_content: '',
        gtag: '',
      },
    };
  },
  computed: {
    fullSiteUrl() {
      const configurable = this.site_domain.domain.includes('join.hmnz.app')
        ? `${this.site_domain.domain}/${this.site_page_path}`.replace('//', '')
        : `${this.site_domain.domain}.com`;
      return `https://${configurable}`;
    },
  },
  async mounted() {
    const res = await fetch('/api/site_pages');
    const { records } = await res.json();
    const { site_domains, site_pages } = records;

    if (site_domains.length === 0 && site_pages.length === 0) {
      await this.$router.push('/settings/company/landing_pages/new');
    }

    this.site_domain.domain = site_domains[0].domain;

    this.landing_page_settings.hero_lead = site_pages[0].page_config.content.hero_lead;
    this.landing_page_settings.button_text = site_pages[0].page_config.content.button_text;
    this.landing_page_settings.hero_headline = site_pages[0].page_config.content.hero_headline;
    this.landing_page_settings.spotlight_lead = site_pages[0].page_config.content.spotlight_lead;
    this.landing_page_settings.form_section_lead = site_pages[0].page_config.content.form_section_lead;
    this.landing_page_settings.spotlight_headline = site_pages[0].page_config.content.spotlight_headline;
    this.landing_page_settings.testimonial_1_name = site_pages[0].page_config.content.testimonial_1_name;
    this.landing_page_settings.testimonial_2_name = site_pages[0].page_config.content.testimonial_2_name;
    this.landing_page_settings.testimonial_3_name = site_pages[0].page_config.content.testimonial_3_name;
    this.landing_page_settings.form_section_headline = site_pages[0].page_config.content.form_section_headline;
    this.landing_page_settings.testimonial_1_content = site_pages[0].page_config.content.testimonial_1_content;
    this.landing_page_settings.testimonial_2_content = site_pages[0].page_config.content.testimonial_2_content;
    this.landing_page_settings.testimonial_3_content = site_pages[0].page_config.content.testimonial_3_content;
    this.landing_page_settings.testimonial_1_image_url = '';
    this.landing_page_settings.testimonial_2_image_url = '';
    this.landing_page_settings.testimonial_3_image_url = '';
    this.landing_page_settings.spotlight_right_column_type =
      site_pages[0].page_config.content.spotlight_right_column_type;
    this.landing_page_settings.spotlight_right_column_content =
      site_pages[0].page_config.content.spotlight_right_column_content;
    this.landing_page_settings.gtag = site_pages[0].page_config.content.gtag;
    this.site_page_id = site_pages[0].id;
    this.site_page_path = site_pages[0].path;
    this.loaded = true;
  },
  methods: {
    updateSitePage() {
      const self = this;
      fetch(`/api/site_pages/${this.site_page_id}`, {
        method: 'PUT',
        body: JSON.stringify({ content: self.landing_page_settings }),
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          self.$store.commit('general/hideLocalLoadingSpinner');
          if (data.status != 'error') {
            self.$store.commit('general/showAlert', {
              alertType: 'success',
              alertTitle: 'Landing Page Updated!',
              alertDescription:
                'Your recruiting landing page has been updated! Use the button below to dismiss this alert.',
            });
          } else {
            self.$store.commit('general/showAlert', {
              alertType: 'error',
              alertTitle: 'Landing Page Update Failed',
              alertDescription: data.message,
            });
          }
        });
    },
    openPage() {
      window.open(this.fullSiteUrl);
    },
  },
};
</script>
